export type DesktopBlockerDetectorResult = {
  isMobileBrowser: boolean;
  blockReason: string;
  userAgent: string;
  criteria: {
    matchMobileUA: boolean;
    platform: string;
    hasTouchSupport: boolean;
  };
};

export const runDesktopBlockerDetector = (): DesktopBlockerDetectorResult => {
  let blockReason = "";
  const criteria = {
    matchMobileUA: false,
    platform: "",
    hasTouchSupport: false,
  };
  if (typeof navigator === "undefined") {
    criteria.matchMobileUA = false;
    criteria.platform = "navigator is undefined";
    criteria.hasTouchSupport = false;
    return {
      isMobileBrowser: false,
      blockReason: "Navigator is not found, this request is not from a browser",
      userAgent: "",
      criteria,
    };
  }

  const userAgent = navigator.userAgent.toLowerCase();
  let isMobileBrowser = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  if (!isMobileBrowser) {
    criteria.matchMobileUA = false;
    blockReason = "UA does not match mobile browser pattern";
  }
  let platform = navigator.platform;
  if (platform) {
    platform = platform.toLowerCase();
    criteria.platform = platform;

    if (platform.includes("win")) {
      isMobileBrowser = false;
      blockReason = "Platform is Windows Desktop";
    }

    if (platform.includes("mac")) {
      const hasTouchSupport = "ontouchstart" in window || navigator.maxTouchPoints > 0;
      isMobileBrowser = hasTouchSupport;
      criteria.hasTouchSupport = hasTouchSupport;
      blockReason = "Platform is Mac Desktop";
    }
  }

  return {
    isMobileBrowser,
    blockReason,
    userAgent,
    criteria,
  };
};

/**
 * Check if device is on desktop
 */
export const initDesktopBlocker = () => {
  const result = {
    shouldBlock: false,
    context: {} as DesktopBlockerDetectorResult,
  };
  const detectorResult = runDesktopBlockerDetector();
  // If the device is not a mobile browser, block the page
  if (!detectorResult.isMobileBrowser) {
    result.shouldBlock = true;
    result.context = detectorResult;
  }
  return result;
};
